module.exports = __webpack_public_path__ + "images/category_lp/tablet/assessment_achievements/3_fec86a8b4a00b80902091c9556798f71.jpg";